import React from 'react';
import { TypedMemo } from '../../common/types';
import { WelcomeView } from '../welcome/WelcomeView';
import { useTour } from './useTour';

/** The `/app/welcome` route: "Show me an example" starts the LaziiBee tour. */
const WelcomeWithTourComponent: React.FC = () => {
  const { start } = useTour();
  return <WelcomeView onExample={start} />;
};

export const WelcomeWithTour = TypedMemo(WelcomeWithTourComponent);
